var collapsible_list_pair_rtlignore_default = {
  "container": "_2wzWY",
  "title": "u-OXq",
  "viewerContainer": "bEBDV",
  "titleContainer": "ShiEg",
  "expandIcon": "fbyKf",
  "dndIcon": "ZMLOQ",
  "RTL": "sT8Wj",
  "LTR": "YmEIn",
  "itemContainer": "ts4X6",
  "itemContainerViewer": "_0H4ho",
  "mouseDown": "fLIR-",
  "innerEditor": "um7ob",
  "item": "c42qC",
  "floatingAddPluginMenuWrapper": "AUNxK",
  "childrenHidden": "_8h7vk"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
